import React, { Component } from 'react';
import { ScrollView, StyleSheet, View, Image, Dimensions, Text, TouchableOpacity, Linking } from 'react-native';
import Pagination from './pages/Pagination';
import Chapter1 from './pages/ch1/Chapter1';
import Chapter2 from './pages/ch2/Chapter2';
import Chapter3 from './pages/ch3/Chapter3';
import Chapter4 from './pages/ch4/Chapter4';
import Chapter5 from './pages/ch5/Chapter5';
import images from "./images/ImagesControl";
//import Appendix1 from './pages/ap1/Appendix1';
import Appendix2 from './pages/ap2/Appendix2';
import Appendix3 from './pages/ap3/Appendix3';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: 1,
            windowDims: Dimensions.get("window"),
        };
    }

    componentDidMount() {
        Dimensions.addEventListener("change", this.dimsHandler);

        var id = 1;
        if (window.localStorage.getItem('id')) {
            id = parseInt(window.localStorage.getItem('id'));
        }
        this.setState({
            id: id
        })
    }

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.dimsHandler);
    }

    dimsHandler = (dims) => {
        this.setState({
            windowDims: dims["window"]
        });
    };

    _changePages(id) {
        window.localStorage.setItem('id', id);

        this.setState({
            id: id
        })

        this.scrollview.scrollTo({ y: 0 });
    }

    render() {
        const state = this.state;
        let pages = null;

        if (state.id === 1) {
            pages = <Chapter1 />;
        } else if (state.id === 2) {
            pages = <Chapter2 />;
        } else if (state.id === 3) {
            pages = <Chapter3 />;
        } else if (state.id === 4) {
            pages = <Chapter4 onPress={this._changePages.bind(this)} />;
            clearInterval();
        } else if (state.id === 5) {
            pages = <Chapter5 onPress={this._changePages.bind(this)} />;
            clearInterval();
        } else if (state.id === 6) {
            // pages = <Appendix1 />;
        } else if (state.id === 7) {
            pages = <Appendix2 />;
        } else if (state.id === 8) {
            pages = <Appendix3 />;
        }

        const windowHeight = state.windowDims.height;

        return (
            <View style={styles.container}>
                <View style={styles.header}>
                    <View style={styles.logoStyle}>
                        <TouchableOpacity onPress={() => Linking.openURL('https://www.multiable.com/EN/home.htm')}>
                            <View style={styles.logoStyle}>
                                <Image source={images.macLogo} style={{ flex: 1 }} />
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
                <View style={[styles.content, { height: windowHeight - 70 - 25 }]}>
                    <Pagination onPress={this._changePages.bind(this)} selectId={state.id} />
                    <ScrollView style={styles.scrollViewStyle}
                        contentContainerStyle={styles.scrollViewStyle}
                        ref={scrollview => { this.scrollview = scrollview }}>
                        {
                            pages
                        }
                    </ScrollView>
                </View>
                <View style={styles.footer}>
                    <Text style={styles.copyRight}>
                        {
                            "© Copyright 2018 | Multiable Company ALL Rights Reserved."
                        }
                    </Text>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
    },
    header: {
        borderBottomWidth: 1,
        height: 70,
        justifyContent: "center",
        paddingLeft: 20
    },
    content: {
        flexDirection: 'row',
        paddingTop: 10,
    },
    footer: {
        alignItems: 'center',
        position: 'absolute',
        paddingBottom: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: 25
    },
    copyRight: {
        fontSize: 10
    },
    scrollViewStyle: {
        flex: 1
    },
    logoStyle: {
        width: 251,
        height: 34
    }
});



// WEBPACK FOOTER //
// ./src/App.js